module.exports = __webpack_public_path__ + "static/media/user-checkin.237f313f.svg";